<template>
    <div class="SX">
       <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoPartyDiscipline">党纪法规></span>
        <span @click="GoFenLei">分类系统></span>
        <span class="red">正文</span>
      </div>
      <!-- 正文 -->
    <div class="zhengwen">
      <h1>关于新形势下党内政治生活的若干准则</h1>
      <div class="first">
        <p >关于新形势下党内政治生活的若干准则</p>
        <p>（2016年10月27日中国共产党第十八届中央委员会第六次全体会议通过）</p>
      </div>
       <div class="date">
         发布时间：2020-5-20&nbsp13:30
       </div>
       <div class="xh"></div>
      <div class="second">
          
        <p>办好中国的事情，关键在党，关键在党要管党、从严治党。党要管党必须从党内政治生活管起，从严治党必须从党内政治生活严起。</p>

        <p>开展严肃认真的党内政治生活，是我们党的优良传统和政治优势。在长期实践中，我们党坚持把开展严肃认真的党内政治生活作为党的建设重要任务来抓，形成了以实事求是、理论联系实际、密切联系群众、批评和自我批评、民主集中制、严明党的纪律等为主要内容的党内政治生活基本规范，为巩固党的团结和集中统一、保持党的先进性和纯洁性、增强党的生机活力积累了丰富经验，为保证完成党在各个历史时期中心任务发挥了重要作用。</p>

        <p>　一九八O年，党的十一届五中全会深刻总结历史经验特别是“文化大革命”的教训，制定了《关于党内政治生活的若干准则》，为拨乱反正、恢复和健全党内政治生活、推进党的建设发挥了重要作用，其主要原则和规定今天依然适用，要继续坚持。</p>

        <p>以毛泽东同志为主要代表的中国共产党人，把马克思列宁主义的基本原理同中国革命的具体实践结合起来，创立了毛泽东思想。毛泽东思想是马克思列宁主义在中国的运用和发展，是被实践证明了的关于中国革命和建设的正确的理论原则和经验总结，是中国共产党集体智慧的结晶。在毛泽东思想指引下，中国共产党领导全国各族人民，经过长期的反对帝国主义、封建主义、官僚资本主义的革命斗争，取得了新民主主义革命的胜利，建立了人民民主专政的中华人民共和国；新中国成立以后，顺利地进行了社会主义改造，完成了从新民主主义到社会主义的过渡，确立了社会主义基本制度，发展了社会主义的经济、政治和文化。</p>
         <p>　十一届三中全会以来，以邓小平同志为主要代表的中国共产党人，总结新中国成立以来正反两方面的经验，解放思想，实事求是，实现全党工作中心向经济建设的转移，实行改革开放，开辟了社会主义事业发展的新时期，逐步形成了建设中国特色社会主义的路线、方针、政策，阐明了在中国建设社会主义、巩固和发展社会主义的基本问题，创立了邓小平理论。邓小平理论是马克思列宁主义的基本原理同当代中国实践和时代特征相结合的产物，是毛泽东思想在新的历史条件下的继承和发展，是马克思主义在中国发展的新阶段，是当代中国的马克思主义，是中国共产党集体智慧的结晶，引导着我国社会主义现代化事业不断前进。</p>
          <p>新形势下，党内政治生活状况总体是好的。同时，一个时期以来，党内政治生活中也出现了一些突出问题，主要是：在一些党员、干部包括高级干部中，理想信念不坚定、对党不忠诚、纪律松弛、脱离群众、独断专行、弄虚作假、庸懒无为，个人主义、分散主义、自由主义、好人主义、宗派主义、山头主义、拜金主义不同程度存在，形式主义、官僚主义、享乐主义和奢靡之风问题突出，任人唯亲、跑官要官、买官卖官、拉票贿选现象屡禁不止，滥用权力、贪污受贿、腐化堕落、违法乱纪等现象滋生蔓延。特别是高级干部中极少数人政治野心膨胀、权欲熏心，搞阳奉阴违、结党营私、团团伙伙、拉帮结派、谋取权位等政治阴谋活动。这些问题，严重侵蚀党的思想道德基础，严重破坏党的团结和集中统一，严重损害党内政治生态和党的形象，严重影响党和人民事业发展。这就要求我们必须继续以改革创新精神加强党的建设，加强和规范党内政治生活，全面提高党的建设科学化水平。</p>
      </div>
    </div>
      
    
    </div>


    </div>
</template>
<script>
export default {
    methods: {
        GoPartyDiscipline() {
      this.$router.push("/PartyDiscipline");
    },
   GoFenLei() {
      this.$router.push("/PartyDiscipline/FenLei");
    }
    },
}
</script>
<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
.zhengwen {
  width: 1200px;
  background-color: white;
  padding: 60px;
  box-sizing: border-box;
}
p {
  text-indent: 2em;
  font-size: 16px;
  color: #333333;
  margin-top: 20px;
}

h1 {
  text-align: center;
  font-size: 28px;
  color: #333333;
}
.first {
  text-align: center;
  font-size: 16px;
  color: #999999;
  margin-top: 28px;
  margin-bottom: 30px;
}
.daohang {
  margin: 20px 0;
}
.first p{
    font-weight: 600;
}
.date{
  color: #999999;
  font-size: 16px;
  text-align: center;
  margin-bottom: 28px;
}
</style>